<template>
  <div id="maDetails">
    <ul class="from">
      <li class="fromItem">
        <div class="key">期刊名称：</div>
        <div class="value">
          <span>{{ maInfo.name }}</span>
          <!--          <span>{{ userData.idCard }}</span>-->
          <div style="display: inline-block">已完成实名认证，无法修改</div>
          <!--          <img src="@/assets/img/userInfo/bi.png" @click=subValue({key:''}) ,value:'' v-if="edit" alt="" />-->
        </div>
      </li>
      <li class="fromItem">
        <div class="key">封面图：</div>
        <div class="value">
          <img class="img" v-lazy="$global.imgUrl + maInfo.coverImg" alt />

          <Upload
            accept=".png,.jpg,.jpeg"
            :headers="{ token: token }"
            :max-size="1024"
            :on-exceeded-size="handleMaxSize"
            :show-upload-list="false"
            class="upload"
            :action="`${$global.uplodeUrl}zw-public/web/common/upload`"
            :on-success="handleSuccess"
          >
            <img
              src="@/assets/img/userInfo/bi.png"
              @click="subValue({ key: 'coverImg', value: '', name: '封面图' })"
              v-if="edit"
              alt
            />
          </Upload>
        </div>
      </li>
      <li class="fromItem">
        <div class="key">LOGO：</div>
        <div class="value">
          <!--          {{$global.imgUrl + maInfo.periodicalLogo}}-->
          <img
            style="width: 40px; height: 40px; border-radius: 50%"
            class="img"
            v-lazy="$global.imgUrl + maInfo.periodicalLogo"
            alt
          />
          <Upload
            accept=".png,.jpg,.jpeg"
            :show-upload-list="false"
            :headers="{ token: token }"
            :max-size="1024"
            :on-exceeded-size="handleMaxSize"
            class="upload"
            :action="`${$global.uplodeUrl}zw-public/web/common/upload`"
            :on-success="periodicalLogoSuccess"
          >
            <img
              src="@/assets/img/userInfo/bi.png"
              @click="
                subValue({ key: 'periodicalLogo', value: '', name: 'LOGO' })
              "
              v-if="edit"
              alt
            />
          </Upload>
          <!--          <span>{{ orgPeriodical[0].name }}</span>-->
          <!--          <img src="@/assets/img/userInfo/bi.png" @click="subValue({key:'periodicalLogo',value:'',name:'LOGO'})"-->
          <!--               v-if="edit" alt />-->
        </div>
      </li>
      <li class="fromItem">
        <div class="key">创刊时间：</div>
        <div class="value">
          <span>{{ maInfo.foundedDate }}</span>
          <img
            src="@/assets/img/userInfo/bi.png"
            @click="
              subValue({ key: 'foundedDate', value: maInfo.foundedDate, name: '创刊时间' })
            "
            v-if="edit"
            alt
          />
        </div>
      </li>
      <li class="fromItem">
        <div class="key">主管单位：</div>
        <div class="value">
          <span v-for="(item,i) in maInfo.responsibleDeptList" :key="i">{{item.orgName}}</span>
          <img
            src="@/assets/img/userInfo/bi.png"
            @click="
              subValue({ key: 'responsibleDeptList', value: maInfo.responsibleDeptList && maInfo.responsibleDeptList.length > 0 ? maInfo.responsibleDeptList : [{orgName: '',}], name: '主管单位' })
            "
            v-if="edit"
            alt
          />
        </div>
      </li>
      <li class="fromItem">
        <div class="key">主办单位：</div>
        <div class="value">
          <span v-for="(item,i) in maInfo.organizerList" :key="i">{{item.orgName}}</span>
          <img
            src="@/assets/img/userInfo/bi.png"
            @click="subValue({ key: 'organizerList', value: maInfo.organizerList && maInfo.organizerList.length > 0 ? maInfo.organizerList : [{orgName: '',}], name: '主办单位' })"
            v-if="edit"
            alt
          />
        </div>
      </li>
      <li class="fromItem">
        <div class="key">出版单位：</div>
        <div class="value">
          <span v-for="(item,i) in maInfo.publishCompanyList" :key="i">{{item.orgName}}</span>
          <img
            src="@/assets/img/userInfo/bi.png"
            @click="
              subValue({ key: 'publishCompanyList', value: maInfo.publishCompanyList && maInfo.publishCompanyList.length > 0 ? maInfo.publishCompanyList : [{orgName: '',}], name: '出版单位' })
            "
            v-if="edit"
            alt
          />
        </div>
      </li>
      <li class="fromItem">
        <div class="key">出版周期：</div>
        <div class="value">
          <span>{{ maInfo.publishPeriod | period }}</span>
          <img
            src="@/assets/img/userInfo/bi.png"
            @click="
              subValue({ key: 'publishPeriod', value: maInfo.publishPeriod, name: '出版周期' })
            "
            v-if="edit"
            alt
          />
        </div>
      </li>
      <li class="fromItem">
        <div class="key">国内统一连续出版物号：</div>
        <div class="value">
          <span>{{ maInfo.cn }}</span>
          <img
            src="@/assets/img/userInfo/bi.png"
            @click="
              subValue({ key: 'cn', value: maInfo.cn, name: '国内统一连续出版物号' })
            "
            v-if="edit"
            alt
          />
        </div>
      </li>
      <li class="fromItem">
        <div class="key">国际统一连续出版物号：</div>
        <div class="value">
          <span>{{ maInfo.issn }}</span>
          <img
            src="@/assets/img/userInfo/bi.png"
            @click="
              subValue({ key: 'issn', value: maInfo.issn, name: '国际统一连续出版物号' })
            "
            v-if="edit"
            alt
          />
        </div>
      </li>
      <li class="fromItem">
        <div class="key">国内邮发代号：</div>
        <div class="value">
          <span>{{ maInfo.codeDomestic }}</span>
          <img
            src="@/assets/img/userInfo/bi.png"
            @click="subValue({ key: 'codeDomestic', value: maInfo.codeDomestic, name: '国内邮发代号' })"
            v-if="edit"
            alt
          />
        </div>
      </li>
      <li class="fromItem">
        <div class="key">期刊分类：</div>
        <div class="value">
          <span>{{ maInfo.subject }}</span>
          <img
            src="@/assets/img/userInfo/bi.png"
            @click="
              subValue({ key: 'subjectId',type: maInfo.subjectId ? maInfo.subjectId.slice(0,2) : '',value: maInfo.subjectId ? maInfo.subjectId : '',name: '期刊分类' })
            "
            v-if="edit"
            alt
          />
        </div>
      </li>
      <li class="fromItem">
        <div class="key">收录网站：</div>
        <div
          class="value"
          v-for="(item, i) in periodicalDatabase"
          :key="item.id"
        >
          <span>{{ item.name }}</span>
          <img
            @click="
              subValue({
                name: '收录网站',
                type: '',
                value: '',
                key: 'periodicalDatabase',
                index: i,
              })
            "
            style="margin-right: 20px"
            src="@/assets/img/userInfo/2222.png"
            v-if="edit"
            alt
          />
        </div>
        <span
          v-if="edit"
          @click="
            subValue({
              name: '收录网站',
              type: '',
              value: '',
              key: 'periodicalDatabase',
              index: NaN,
            })
          "
        >
          <img
            style="cursor: pointer; margin-left: 10px"
            src="@/assets/img/userInfo/bi.png"
            v-if="edit"
            alt
          />
        </span>
      </li>
      <li class="fromItem">
        <div class="key">收录数据库：</div>
        <div class="value">
          <span>{{ maInfo.coreName }}</span>
          <img
            src="@/assets/img/userInfo/bi.png"
            @click="
              subValue({ key: 'coreName', value: maInfo.coreName, name: '收录数据库' })
            "
            v-if="edit"
            alt
          />
        </div>
      </li>
      <li class="fromItem">
        <div class="key">出版地：</div>
        <div class="value">
          <span>{{ maInfo.publishAddrProvince }} - {{ maInfo.publishAddrCity }}</span>
          <img
            src="@/assets/img/userInfo/bi.png"
            @click="
              subValue({
                key: 'publishAddrProvince',
                value: [maInfo.publishAddrProvince,maInfo.publishAddrCity],
                name: '出版地',
              })
            "
            v-if="edit"
            alt
          />
        </div>
      </li>
      <li class="fromItem">
        <div class="key">E-mail：</div>
        <div class="value">
          <span>{{ maInfo.email }}</span>
          <img
            src="@/assets/img/userInfo/bi.png"
            @click="subValue({ key: 'email', value: maInfo.email, name: 'E-mail' })"
            v-if="edit"
            alt
          />
        </div>
      </li>
    </ul>
    <div class="btn">
      <div
        v-if="!edit"
        @click="setEdit"
        :class="maInfo.reviewStatus == 2 ? 'affirm' : 'close'"
      >
        {{ maInfo.reviewStatus | reviewStatusFilter }}
      </div>
      <div v-if="edit" @click="back" class="close">取消</div>
      <div v-if="edit" @click="sub" class="affirm">保存</div>
    </div>
    <Modal
      :scrollable="true"
      v-model="alert"
      width="572px"
      class-name="vertical-center-modal"
      :footer-hide="true"
      :closable="false"
      :mask-closable="false"
    >
      <div class="alert">
        <div class="title">{{ changeObj.name }}</div>
        <div class="content">
          <template v-if="changeObj.key === 'periodicalDatabase'">
            <Input
              v-model="changeObj.value"
              style="width: 200px;margin: 20px 5px 0 57px;"
              :placeholder="`请输入网站名`"
            />
            <Input
              v-model="changeObj.type"
              style="width: 200px;margin-top: 20px;"
              :placeholder="`请输入网站地址`"
            />
          </template>
          <template v-else-if="changeObj.key === 'publishPeriod'">
            <Select style="width: 462px; margin-left: 57px; margin-top: 20px" v-model="changeObj.value">
              <Option :value="1"> 年刊 </Option>
              <Option :value="2"> 半年刊 </Option>
              <Option :value="3"> 季刊 </Option>
              <Option :value="4"> 双月刊 </Option>
              <Option :value="5"> 月刊 </Option>
              <Option :value="6"> 半月刊 </Option>
              <Option :value="7"> 旬刊 </Option>
              <Option :value="8"> 周刊 </Option>
              <Option :value="9"> 周二刊 </Option>
            </Select>
          </template>
          <template v-else-if="changeObj.key === 'foundedDate'">
            <DatePicker
              :value="changeObj.value"
              @on-change="changeDate"
              type="year"
              style="width: 462px; margin-left: 57px; margin-top: 20px"
            ></DatePicker>
          </template>
          <template v-else-if="changeObj.key === 'subjectId'">
            <Select
              v-model="changeObj.type"
              style="width: 200px;margin: 20px 5px 0 57px;"
              @on-change="journalChange"
            >
              <Option v-for="item in journalList" :key="item.id" :value="item.code">
                {{ item.name }}
              </Option>
            </Select>
            <Select v-model="changeObj.value" style="width: 200px;margin-top: 20px;" @on-change="journalTwoChange">
              <Option v-for="item in journalList2" :key="item.id" :value="item.code">
                {{ item.name }}
              </Option>
            </Select>
          </template>
          <template v-else-if="changeObj.key === 'responsibleDeptList'">
            <div>
              <div v-for="(item,i) in changeObj.value" :key="i" style="display: flex;align-items: center;margin-top: 20px;">
                <Input
                  v-model="item.orgName"
                  type="text"
                  style="width:350px; margin-left: 57px;"
                  :placeholder="'请输入主管单位'"
                />
                <div v-show="(i===0 && changeObj.value.length>1)||i>0" class="addIcon subIcon" @click="delPeriodicalDatabase(i)">-</div>
                <div v-show="changeObj.value.length-1 === i" class="addIcon" @click="addPeriodicalDatabase(i)">+</div>
              </div>
            </div>
          </template>
          <template v-else-if="changeObj.key === 'organizerList'">
            <div>
              <div v-for="(item,i) in changeObj.value" :key="i" style="display: flex;align-items: center;margin-top: 20px;">
                <Input
                  v-model="item.orgName"
                  type="text"
                  style="width: 350px; margin-left: 57px;"
                  :placeholder="'请输入主办单位'"
                />
                <div v-show="(i===0 && changeObj.value.length>1)||i>0" class="addIcon subIcon" @click="delPeriodicalDatabase(i)">-</div>
                <div v-show="changeObj.value.length-1 === i" class="addIcon" @click="addPeriodicalDatabase(i)">+</div>
              </div>
            </div>
          </template>
          <template v-else-if="changeObj.key === 'publishCompanyList'">
            <div>
              <div v-for="(item,i) in changeObj.value" :key="i" style="display: flex;align-items: center;margin-top: 20px;">
                <Input
                  v-model="item.orgName"
                  type="text"
                  style="width: 350px; margin-left: 57px;"
                  :placeholder="'请输入出版单位'"
                />
                <div v-show="(i===0 && changeObj.value.length>1)||i>0" class="addIcon subIcon" @click="delPeriodicalDatabase(i)">-</div>
                <div v-show="changeObj.value.length-1 === i" class="addIcon" @click="addPeriodicalDatabase(i)">+</div>
              </div>
            </div>
          </template>
          <template v-else-if="changeObj.key === 'publishAddrProvince'">
            <div style="margin-left: 57px; margin-top: 20px">
              <Select
                style="width: 200px; margin-right: 5px"
                v-model="pre"
                @on-change="handerChange"
              >
                <Option v-for="item in preList" :key="item.id" :value="item.code">
                  {{ item.name }}
                </Option>
              </Select>
              <Select style="width: 200px" v-model="city" @on-change="handerChangeCity">
                <Option v-for="item in cityList" :key="item.id" :value="item.code">
                  {{ item.name }}
                </Option>
              </Select>
            </div>
          </template>
          <template v-else-if="changeObj.key === 'coreName'">
            <div style="margin-left: 57px; margin-top: 20px">
              <CheckboxGroup v-model.trim="changeObj.value">
                <Checkbox
                  v-for="v in includeList"
                  :key="v.id"
                  :label="v.dbName"
                ></Checkbox>
              </CheckboxGroup>
            </div>
          </template>
          <template v-else>
            <Input
              v-model="changeObj.value"
              type="text"
              style="width: 462px; margin-left: 57px; margin-top: 20px"
              :placeholder="`请输入${changeObj.name}`"
            />
          </template>
        </div>
        <div class="btn">
          <Button v-throttleClick @click="closeAlert" class="close">取消</Button>
          <Button v-throttleClick @click="affirm" class="affirm">确认</Button>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "maDetails",
  computed: {
    ...mapState(["token"]),
  },
  props: ["maInfo", "periodicalDatabase"],
  data() {
    return {
      alert: false,
      edit: false,
      url: "",
      pre: "",
      preList: [], // 出版地省份列表
      city: "",
      cityList: [], // 出版地市列表
      includeList: [], // 收录数据库
      journalList: [], // 期刊分类一级下拉选项
      journalList2: [], // 期刊分类二级下拉选项
      changeObj: {
        key: "",
        type: "",
        name: "",
        value: null,
        index: null,
      },
    };
  },
  watch: {
    maInfo(newValue) {
      this.url = newValue.coverImg;
    },
  },
  methods: {
    delPeriodicalDatabase(i) {
      if (this.changeObj.value.length === 1) return
      this.changeObj.value.splice(i, 1);
    },
    addPeriodicalDatabase(i) {
      if (this.changeObj.value[i].orgName === '') return
      this.changeObj.value.push({orgName: ""})
    },
    // 二级期刊分类改变
    journalTwoChange(code) {
      this.changeObj.value = code;
    },
    // 一级期刊分类改变
    async journalChange(code) {
      this.changeObj.type = code
      const resp = await this.$apis.hundredServe.getListByParentCode({ parentCode: code });
      this.journalList2 = resp.perClaTwoList; // 期刊分类一级下拉选项
    },
    // 获取期刊分类一级列表
    async classificationOneList() {
      const resp = await this.$apis.hundredServe.getPerOneList();
      this.journalList = resp.perClaOneList; // 期刊分类一级下拉选项
    },
    // 创刊时间改变
    changeDate(date) {
      this.changeObj.value = date;
    },
    // 关闭编辑弹出层
    closeAlert() {
      this.changeObj = {
        key: "",
        type: "",
        name: "",
        value: null,
        index: null,
      }
      this.alert = false;
    },
    // 编辑弹窗点击确认
    affirm() {
      if (this.changeObj.key === "periodicalDatabase") {
        if (this.changeObj.type === "" || this.changeObj.value === "") {
          this.$Message.error("内容不能为空");
          return;
        } else {
          this.periodicalDatabase.push({
            name: this.changeObj.value,
            url: this.changeObj.type,
          });
        }
      } else if(this.changeObj.key === "responsibleDeptList" || this.changeObj.key === "organizerList" || this.changeObj.key === "publishCompanyList") {
         if (this.changeObj.value.some(item => item.orgName === '')) {
          this.$Message.error("内容不能为空");
          return;
        } else {
          this.maInfo[this.changeObj.key] = [...this.changeObj.value];
        }
      } else if(this.changeObj.key === "subjectId") {
        let arr = this.journalList2.filter(item  => item.code === this.changeObj.value)
        this.maInfo.subject = arr[0].name
        this.maInfo.subjectId = this.changeObj.value
      } else if(this.changeObj.key === "coreName") {
        this.maInfo.coreName = this.changeObj.value.join()
      } else if(this.changeObj.key === "cn" || this.changeObj.key === "issn") {
        if (this.changeObj.value === "") {
          this.$Message.error("内容不能为空");
          return;
        } else {
          this.maInfo[this.changeObj.key] = this.changeObj.value;
        }
      } else if(this.changeObj.key === "publishAddrProvince") {
        this.maInfo.publishAddrProvince = this.changeObj.value[0]
        this.maInfo.publishAddrCity = this.changeObj.value[1]
      } else {
        this.maInfo[this.changeObj.key] = this.changeObj.value;
      }
      this.closeAlert()
    },
    // 点击编辑图标,打开编辑弹窗
    subValue(e) {
      if (e.key === "coverImg" || e.key === "periodicalLogo") return;
      if (e.key === "periodicalDatabase") {
        if (!isNaN(e.index)) {
          // 删除收录网站
          this.periodicalDatabase.splice(e.index, 1);
          return;
        }
      } else if (e.key === "subjectId") {
        this.classificationOneList()
        this.journalChange(e.type)
      } else if (e.key === "publishAddrProvince") { // 出版地
        this.pre = ''
        this.city = ''
        this.getProList(e.value);
      } else if (e.key === "coreName") { // 收录数据库
        e.value = e.value ? e.value.split(',') : []
        this.getIncludeList()
      }
      this.changeObj = e;
      this.alert = true;
    },
    // 获取收录数据库选择项
    async getIncludeList() {
      const resp = await this.$apis.xsjhServe.getIncludeList();
      this.includeList = resp.dbList;
    },
    // 获取及回显出版地省份列表
    async getProList(arr) {
      let res = await this.$apis.userServe.proList();
      this.preList = res.content.provinceList;
      this.preList.forEach((item) => {
        if (item.name == arr[0]) this.pre = item.code
      });
      this.handerChange(arr[1])
    },
    // 获取出版地城市列表
    async handerChange(city) {
      let res = await this.$apis.userServe.cityList({ provinceCode: this.pre });
      this.cityList = res.content.cityList;
      if (city) {
        this.cityList.forEach((item) =>{
          if (item.name == city) this.city = item.code
        });
        this.handerChangeCity()
      }
    },
    handerChangeCity() {
      let preName = "";
      let cityName = "";
      this.preList.forEach((item) =>
        item.code == this.pre ? (preName = item.name) : ""
      );
      this.cityList.forEach((item) =>
        item.code == this.city ? (cityName = item.name) : ""
      );
      this.changeObj.value = [preName,cityName];
    },
    back() {
      this.$emit("getDetails");
      this.edit = false;
    },
    async sub() {
      let obj = {
        periodicalDatabase: this.periodicalDatabase,
        periodical: this.maInfo,
      };
      // for (const key in obj.periodical) {
      //   if ( key !== "coverImg" || key !== "periodicalLogo") {
      //     if (obj.periodical[key] === "") {
      //       this.$Message.error("不能为空");
      //       return;
      //     }
      //   }
      // }
      let { data } = await this.$apis.userServe.setMaInfo(obj);
      if (data.resultCode === '200') {
        this.$Message.success("成功");
        this.edit = false;
        let res = await this.$apis.loginServe.getUserInfo();
        let userObj = {
          token: sessionStorage.getItem("token"),
          hasLogin: true,
          userInfo: res.content,
        };
        this.$store.commit("loginInfo", userObj);
        this.back();
      }
    },
    setEdit() {
      if (this.maInfo.reviewStatus === 0 || this.maInfo.reviewStatus === 1)
        return;
      this.edit = true;
    },
    handleMaxSize(file) {
      this.$Notice.warning({
        title: "图片上传过大",
        desc: file.name + "该文件大小超过1M.",
      });
    },
    handleSuccess(res, file) {
      console.log(res, file, "res, file");
      this.maInfo["coverImg"] = res.content.url;
    },
    periodicalLogoSuccess(res) {
      this.$set(this.maInfo, "periodicalLogo", res.content.url);
    },
  },
  filters: {
    reviewStatusFilter(num) {
      if (num === 0) {
        return "审核中";
      } else if (num === 1) {
        return "待认领";
      } else if (num === 2) {
        return "编辑";
      } else {
        return "不通过";
      }
    },
    period: function (num) {
      if (num == 1) {
        return `年刊`;
      } else if (num == 2) {
        return `半年刊`;
      } else if (num == 3) {
        return `季刊`;
      } else if (num == 4) {
        return `双月刊`;
      } else if (num == 5) {
        return `月刊`;
      } else if (num == 6) {
        return `半月刊`;
      } else if (num == 7) {
        return `旬刊`;
      } else if (num == 8) {
        return `周刊`;
      } else if (num == 9) {
        return `周二刊`;
      } else {
        return `nan`;
      }
      // 1 年刊 2半年刊 3 季刊 4 双月刊 5 月刊 6 半月刊 7 旬刊 8 周刊 9 周二刊
    },
  },
};
</script>

<style lang="scss" scoped>
.alert {
  .subject::-webkit-scrollbar {
    width: 4px;
  }

  .subject::-webkit-scrollbar-thumb {
    width: 4px;
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: rgba(0, 0, 0, 0.2);
  }

  .subject::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 0;
    background: rgba(0, 0, 0, 0.1);
  }

  .subject {
    height: 200px;
    overflow-y: scroll;
  }

  .titleItem {
    margin-left: 77px;
    margin-top: 50px;
    font-weight: 400;
    color: #333333;
    line-height: 24px;
    height: 25px;
    font-size: 24px;
  }
  
  .addIcon {
    margin: 0 10px;
    width: 15px;
    height: 15px;
    line-height: 13px;
    text-align: center;
    font-size: 16px;
    color: #4ec0ff;
    border: 1px dotted #4ec0ff;
    cursor: pointer;
  }
  .subIcon {
    margin-right: 0;
    line-height: 9px;
  }

  .btn {
    margin-top: 34px;
    width: 100%;
    height: 120px;
    //background: pink;
    display: flex;
    align-items: center;
    justify-content: center;

    .close {
      text-align: center;
      line-height: 38px;
      width: 72px;
      height: 38px;
      background: #ffffff;
      border: 1px solid #d2d2d2;
      border-radius: 8px;
      margin-right: 13px;
      outline: none;
      cursor: pointer;
      color: #333;
    }

    .affirm {
      margin-left: 13px;
      text-align: center;
      line-height: 38px;
      width: 70px;
      height: 36px;
      color: #fff;
      background: #007fff;
      border-radius: 8px;
      cursor: pointer;
    }
  }

  .addList {
    margin-left: 57px;
    margin-top: 20px;

    width: 80%;
    display: flex;
    flex-wrap: wrap;

    div {
      width: 20%;
      //background: pink;
      position: relative;

      span {
        position: absolute;
        top: -10px;
        right: 40px;
        width: 3px;
        height: 3px;
        display: block;
        font-size: 3px;
        cursor: pointer;
      }
    }
  }

  .leaveOne {
    margin-left: 57px;
    margin-top: 20px;

    width: 80%;
    display: flex;
    flex-wrap: wrap;

    .oneItem {
      //text-align: center;

      height: 50px;
      //background: pink;
      width: 25%;
    }

    .threeItem {
      margin-top: 20px;
      width: 100%;

      .name {
        //width: 54px;
        display: inline-block;
      }
    }

    .twoItem {
      margin-top: 20px;
      width: 25%;

      .name {
        //width: 54px;
        display: inline-block;
      }
    }
  }

  .title {
    margin-left: 57px;
    margin-top: 50px;
    height: 25px;
    font-size: 24px;
    //background: yellow;
    font-family: Microsoft YaHei;
    font-weight: 900;
    color: #333333;
    line-height: 24px;
  }
}

#maDetails {
  margin-top: 15px;
  width: 1200px;
  min-height: 790px;
  padding-top: 50px;
  background: #ffffff;
  box-shadow: 0px 7px 15px 1px rgba(22, 26, 100, 0.13);

  .upload {
    display: inline-block;
  }

  .btn {
    width: 1200px;
    display: flex;
    justify-content: center;
    align-items: center;

    height: 50px;
    //background: pink;
    .close {
      text-align: center;
      line-height: 38px;
      width: 72px;
      height: 38px;
      background: #ffffff;
      border: 1px solid #d2d2d2;
      border-radius: 8px;
      margin-right: 13px;
      cursor: pointer;
    }

    .affirm {
      margin-left: 13px;
      text-align: center;
      line-height: 38px;
      width: 70px;
      height: 36px;
      color: #fff;
      background: #007fff;
      border-radius: 8px;
      cursor: pointer;
    }
  }

  .from {
    margin-left: 70px;
    margin-bottom: 30px;

    .fromItem {
      display: flex;
      align-items: flex-end;
      min-height: 50px;
      margin-bottom: 10px;

      .key {
        width: 105px;
      }

      .value {
        span {
          margin-right: 20px;
        }

        img {
          cursor: pointer;
        }

        div {
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #666666;
        }

        .img {
          width: 70px;
          height: 98px;
          margin-right: 20px;
        }
      }
    }
  }
}
</style>
